<template>
    <div class="p-relative">
        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents|CitizenStatements.Document', common: data.item.iscommon })">
                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.regnumber`]="{ item }">
                    <td class="clt-col-wrap text-start">
                        {{ item.regnumber }}
                    </td>
                </template>

                <template v-slot:[`item.regdate`]="{ item }">
                    {{ formatDate(item.regdate) }}
                </template>

                <template v-slot:[`item.correspondent`]="{ item }">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.correspondent">
                            {{item.correspondent}}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.theme`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <v-doc-type-chip v-if="item.issubstitution" :type="'Substitution'" :text="$t('Замещение')"/>
                        <v-common-chip v-if="$helpers.getCommonStatusForList(item)" :document-type="item.doctypeof"/>
                        <v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.theme">
                                {{item.theme}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.controldate`]="{ item }">
                    {{ formatDate(item.controldate) }}
                </template>

                <template v-slot:[`item.svodname`]="{ item }">
                    <v-workplace-chip 
                    v-if="item.svodname"
                    :id="item.svodworkplaceid"
                    :name="item.svodname"
                />
                </template>

                <template v-slot:[`item.controldays`]="{ item }">
                    <StatusChip :status="avaibleStatuses[$helpers.calculateDocumentStatus('1',item.controldate, item.execdate, true)]"/>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import StatusChip from '@/components/global/chips/StatusChip';

export default {
    name: "OrdersSvetofor",
    components: {
        Toolbar,
        SearchPanel,
        StatusChip,
    },
    computed:{
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        headers() {
            return [
                { text: this.$t("Номер"), value: 'regnumber', width: '150px'  },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px'  },
                { text: this.$t("Корреспондент"), value: 'correspondent', width: '20%' },
                { text: this.$t("Краткое_содержание"), value: 'theme' },
                { text: this.$t("Срок"), value: 'controldate', width: '110px'  },
                { text: this.$t("Исполнитель"), value: 'svodname', width: '110px'  },
                { text: this.$t("Статус"), value: 'controldays', sortable: false, width: '150px'  }
            ];
        },
        search: {
            get: function() {
                return this.$store.getters[`correspondence/completed/getSearch`];
            },
            set: _.debounce(function(v) {
                this.$store.commit(`correspondence/completed/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`correspondence/completed/SET_SEARCH`, v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters[`correspondence/completed/getTableOptions`];
            },
            set: function(newValue) {
                this.$store.commit(`correspondence/completed/SET_TABLE_OPTION`, newValue);
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        },
    },
    data: () => {
        return {
            loading: true,
            total: 0,            
            entities: [],
            paginationPageCount: 0,
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        resetPage() {
            this.$store.commit('correspondence/completed/SET_TABLE_OPTION_PAGE', 1);
        },
        formatDate(value) {
            if (!value)
                return '';

            return this.$moment(value).format('DD.MM.YYYY');
        },
        onToolbarClick(event, btn){
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.getData();
        },
        async getData() {

            this.setOverlayVisible({ visible: true });    

            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `/api/correspondence/list?collection=Svetofor&filter=${this.getTableFilterObject()}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            if (this.total > 0){
                this.columnIndex = {};
                Object.keys(this.entities[0]).forEach((key, index) => {
                    this.columnIndex[key] = index + 1; 
                });
            }
            this.loading = false;
            this.setOverlayVisible({ visible: false });
            this.$eventBus.$emit('update_correspondents_counters');
        },
        getTableFilterObject() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            const sortColumn = sortBy[0] ?? "regdate";
            const OrderDir = sortDesc[0] ?? false;
            const OrderBy = this.columnIndex?.[sortColumn] ?? 4;
            return JSON.stringify({ ControlState: '2', SearchStr: this.search, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
    },
    watch: {
        search: 'getData',
        options: {
            handler: 'getData',
            deep: true
        }
    },
    async created() {
        let menu = [
            {
                "Action": "Refresh",
                "Icon": "refresh",
                "Items": null,
                "Text": "Обновить",
                "ToolTip": "Обновить_форму",
                "Type": null,
                Localize: true
            }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu });
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    },
}
</script>
